import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const defaultVariants: [string, string] = ['common.yes', 'common.no'];

@Pipe({ name: 'eitherOr' })
export class EitherOrPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  transform(value: boolean, variants: [string | number, string | number] = defaultVariants): string | number {
    const key = value ? variants[0] : variants[1];
    return key ? this._translate.instant(key.toString()) : '';
  }
}
